module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/thunderstorms-day-rain-db6e82d0b5e11ac8686710256c79229a.svg";